import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum.ts";
import { QueueTransactionCommandEnum } from "jadro-pico/enums/common/QueueTransactionCommandEnum.ts";
import { RequestQueueStateEnum } from "../Offline/requestQueueItems.ts";
import { defineResources } from "./defineResources.ts";

export const RequestQueueResources = defineResources({
  [LanguageEnum.CS]: {
    title: "Fronta požadavků",
    closeAriaLabel: "Zavřít",
    pendingTitle: "Čeká na dokončení",
    historyTitle: "Historie",
    showMore: "Zobrazit další",
    emptyHeadline: "Nic nečeká",
    emptySupporting: "Uložení, která ještě nejsou potvrzená, se objeví tady.",
    retryLabel: "Zkusit znovu",
    linksErrorHeadline: "Odkazy na ostatní aplikace se nepodařilo načíst",
    historyEmptyHeadline: "Zatím nic",
    historyEmptySupporting: "Dokončená uložení se objeví tady.",
    errorHeadline: "Historii se nepodařilo načíst",
    unknownLabel: "Uložení",
    state: {
      [RequestQueueStateEnum.WAITING_TO_SEND]: "Čeká na odeslání",
      [RequestQueueStateEnum.SENDING]: "Odesílá se…",
      [RequestQueueStateEnum.AWAITING_WRITE]: "Čeká na uložení",
      [RequestQueueStateEnum.NOT_SENT]: "Nepodařilo se odeslat",
      [RequestQueueStateEnum.NOT_STORED]: "Neuložilo se",
      [RequestQueueStateEnum.STORED]: "Uloženo",
    },
    command: {
      [QueueTransactionCommandEnum.UPDATE_USER_PROFILE]: "Uložení profilu",
      [QueueTransactionCommandEnum.UPDATE_USER]: "Uložení účtu",
      [QueueTransactionCommandEnum.CREATE_USER]: "Založení účtu",
      [QueueTransactionCommandEnum.CREATE_RACE_REGISTRATION]: "Registrace na závod",
      [QueueTransactionCommandEnum.UPDATE_RACE_REGISTRATION]: "Úprava přihlášky",
      [QueueTransactionCommandEnum.UPDATE_RACER_PROFILE]: "Uložení profilu závodníka",
    },
  },
  [LanguageEnum.EN]: {
    title: "Request queue",
    closeAriaLabel: "Close",
    pendingTitle: "Waiting to finish",
    historyTitle: "History",
    showMore: "Show more",
    emptyHeadline: "Nothing pending",
    emptySupporting: "Saves that are not confirmed yet show up here.",
    retryLabel: "Try again",
    linksErrorHeadline: "The links to the other apps could not be loaded",
    historyEmptyHeadline: "Nothing yet",
    historyEmptySupporting: "Finished saves show up here.",
    errorHeadline: "The history could not be loaded",
    unknownLabel: "Save",
    state: {
      [RequestQueueStateEnum.WAITING_TO_SEND]: "Waiting to be sent",
      [RequestQueueStateEnum.SENDING]: "Sending…",
      [RequestQueueStateEnum.AWAITING_WRITE]: "Waiting to be stored",
      [RequestQueueStateEnum.NOT_SENT]: "Could not be sent",
      [RequestQueueStateEnum.NOT_STORED]: "Was not stored",
      [RequestQueueStateEnum.STORED]: "Stored",
    },
    command: {
      [QueueTransactionCommandEnum.UPDATE_USER_PROFILE]: "Profile save",
      [QueueTransactionCommandEnum.UPDATE_USER]: "Account save",
      [QueueTransactionCommandEnum.CREATE_USER]: "Account creation",
      [QueueTransactionCommandEnum.CREATE_RACE_REGISTRATION]: "Race registration",
      [QueueTransactionCommandEnum.UPDATE_RACE_REGISTRATION]: "Entry update",
      [QueueTransactionCommandEnum.UPDATE_RACER_PROFILE]: "Driver profile save",
    },
  },
});
